var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-container"
  }, [_c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), _c("el-switch", {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "15px"
    },
    attrs: {
      disabled: !_vm.listQuery.dealerId,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    on: {
      change: _vm.handleAdditionalFilters
    },
    model: {
      value: _vm.applyFilters,
      callback: function ($$v) {
        _vm.applyFilters = $$v;
      },
      expression: "applyFilters"
    }
  }), _vm.applyFilters ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      placeholder: "Payment Type"
    },
    on: {
      change: _vm.handleAdditionalFilters
    },
    model: {
      value: _vm.query.paymentType,
      callback: function ($$v) {
        _vm.$set(_vm.query, "paymentType", $$v);
      },
      expression: "query.paymentType"
    }
  }, _vm._l(["Credit Note", "Debit Note", "Credit Note-Item Wise", "Debit Note-Item Wise", "Purchase", "Credit Note Inward", "Invoice", "Payment"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1) : _vm._e(), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "mini",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), (_vm.isSuperAdmin || _vm.isAccountManager) && !_vm.isPaymentManager ? _c("router-link", {
    staticClass: "margin-horizontal",
    attrs: {
      to: "/ledgers/add/?timed=" + new Date().getTime()
    }
  }, [(_vm.isSuperAdmin || _vm.isAccountManager) && !_vm.isPaymentManager ? _c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "warning",
      size: "mini",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.isSuperAdmin ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item margin-horizontal",
    attrs: {
      type: "info",
      size: "mini",
      icon: "el-icon-plus"
    },
    on: {
      click: function ($event) {
        _vm.importDialogVisible = true;
      }
    }
  }, [_vm._v(" Import Ledger ")]) : _vm._e(), !_vm.applyFilters ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document",
      disabled: !_vm.listQuery.dealerId
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]) : _vm._e(), _vm.query.paymentType ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "danger",
      size: "mini",
      icon: "el-icon-document",
      disabled: !_vm.listQuery.dealerId
    },
    on: {
      click: _vm.handleApplyFiltersExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]) : _vm._e(), !_vm.applyFilters ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-bottom",
      disabled: !_vm.listQuery.dealerId
    },
    on: {
      click: _vm.handlePDFDownload
    }
  }, [_vm._v(" Export as PDF ")]) : _vm._e()], 1), _vm.listQuery.dealerId && !_vm.applyFilters ? _c("el-row", {
    staticStyle: {
      "margin-right": "110px"
    },
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "align-right",
    attrs: {
      span: 24
    }
  }, [_vm._v(" Opening Balance: "), _c("inr", {
    attrs: {
      number: Math.round(_vm.openingBalance)
    }
  })], 1)], 1) : _vm._e(), !_vm.listQuery.dealerId ? _c("el-empty", {
    attrs: {
      description: "Please Select a Dealer",
      "image-size": 200
    }
  }) : _vm._e(), _vm.listQuery.dealerId ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      "summary-method": _vm.getSummaries,
      "show-summary": "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "130",
      label: "ID",
      prop: "id",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.id))])];
      }
    }], null, false, 2447914085)
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      label: "Date",
      prop: "createdTimestamp",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm.isSuperAdmin ? _c("el-tooltip", {
          attrs: {
            content: "Edit date",
            placement: "top",
            "open-delay": 400
          }
        }, [_c("b", {
          staticStyle: {
            cursor: "pointer",
            color: "#934054",
            "border-bottom": "1px dashed #934054",
            "padding-bottom": "1px"
          },
          on: {
            click: function ($event) {
              return _vm.openDateEditDialog(scope.row);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.formatDate(scope.row.createdTimestamp)) + " "), _c("i", {
          staticClass: "el-icon-edit",
          staticStyle: {
            "font-size": "12px"
          }
        })])]) : _c("b", [_vm._v(" " + _vm._s(_vm.formatDate(scope.row.createdTimestamp)) + " ")])];
      }
    }], null, false, 3013752910)
  }), _c("el-table-column", {
    attrs: {
      width: "280",
      label: "Invoice",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row, _scope$row2, _scope$row$transactio;
        return [scope.row.transactionId ? _c("span", [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          }
        }, [_vm._v(_vm._s(scope.row.paymentType))]), _c("el-tooltip", {
          attrs: {
            effect: "dark",
            content: `Description: ${((_scope$row = scope.row) === null || _scope$row === void 0 || (_scope$row = _scope$row.transaction) === null || _scope$row === void 0 ? void 0 : _scope$row.comments) || ((_scope$row2 = scope.row) === null || _scope$row2 === void 0 ? void 0 : _scope$row2.comments)} \nTransaction Reference: ${((_scope$row$transactio = scope.row.transaction) === null || _scope$row$transactio === void 0 ? void 0 : _scope$row$transactio.referenceNumber) || ""}`,
            placement: "top-start"
          }
        }, [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v(" " + _vm._s(`Reference No.: ${scope.row.transaction.referenceNumber}`) + " ")])], 1)], 1) : _c("span", [scope.row.ordersDispatch ? _c("el-link", {
          attrs: {
            type: "primary",
            target: "_blank",
            disabled: scope.row.fromTally
          },
          on: {
            click: function ($event) {
              return _vm.viewDispatchInvoice(scope.row.ordersDispatchId);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.ordersDispatch.invoiceNumber) + " "), ["Credit Note-Item Wise", "Debit Note-Item Wise", "Replacement"].includes(scope.row.paymentType) ? _c("span", [_vm._v(" - " + _vm._s(scope.row.paymentType) + " ")]) : _vm._e()]) : _c("span", [_c("el-tag", {
          attrs: {
            type: "primary",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.paymentType) + " ")]), _c("el-tooltip", {
          attrs: {
            effect: "dark",
            content: `Description: ${scope.row.comments}`
          }
        }, [scope.row.transactionReference ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v(" " + _vm._s(`Reference: ${scope.row.transactionReference}`) + " ")]) : _vm._e()], 1), ["Credit Note", "Credit Note-Item Wise", "Debit Note", "Debit Note-Item Wise", "Purchase", "Credit Note Inward"].includes(scope.row.paymentType) && scope.row.ledgerInvoiceNumber ? _c("span", [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("(" + _vm._s(scope.row.ledgerInvoiceNumber) + ")")])], 1) : _vm._e()], 1)], 1)];
      }
    }], null, false, 1568585031)
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      label: "Narration",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row3, _scope$row$transactio2, _scope$row4, _scope$row$transactio3;
        return [_c("el-tooltip", {
          attrs: {
            effect: "dark",
            content: ((_scope$row3 = scope.row) === null || _scope$row3 === void 0 ? void 0 : _scope$row3.comments) || ((_scope$row$transactio2 = scope.row.transaction) === null || _scope$row$transactio2 === void 0 ? void 0 : _scope$row$transactio2.comments) || "",
            placement: "top"
          }
        }, [_c("b", {
          staticClass: "ellipsis-text",
          staticStyle: {
            cursor: "pointer",
            color: "black"
          },
          on: {
            click: function ($event) {
              return _vm.handleClick(scope.row);
            }
          }
        }, [_vm._v(" " + _vm._s(((_scope$row4 = scope.row) === null || _scope$row4 === void 0 ? void 0 : _scope$row4.comments) || ((_scope$row$transactio3 = scope.row.transaction) === null || _scope$row$transactio3 === void 0 ? void 0 : _scope$row$transactio3.comments) || "") + " ")])])];
      }
    }], null, false, 3428491696)
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      label: "Debit",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.action === "debit" ? _c("span", [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "danger"
          }
        }, [_c("inr", {
          attrs: {
            number: Math.round(scope.row.amount)
          }
        })], 1)], 1) : _c("span", [_vm._v("0")])];
      }
    }], null, false, 951392657)
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      label: "Credit",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.action === "credit" ? _c("span", [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          }
        }, [_c("inr", {
          attrs: {
            number: Math.round(scope.row.amount)
          }
        })], 1)], 1) : _c("span", [_vm._v("0")])];
      }
    }], null, false, 4254340730)
  }), !_vm.query.paymentType ? _c("el-table-column", {
    attrs: {
      width: "140",
      label: "Balance",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.balance
          }
        })];
      }
    }], null, false, 772219225)
  }) : _vm._e(), !_vm.isAgent && !_vm.isReadOnly && !_vm.query.paymentType ? _c("el-table-column", {
    attrs: {
      label: "E-Invoice",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.eInvoiceUrl ? _c("div", [_vm._v(" E-Invoice: "), scope.row.eInvoiceUrl ? _c("el-link", {
          attrs: {
            type: "primary",
            icon: "el-icon-link",
            target: "_blank",
            href: scope.row.eInvoiceUrl
          }
        }) : _vm._e()], 1) : _vm._e(), scope.row.ewayBillUrl ? _c("div", [_vm._v(" E-Way: "), scope.row.ewayBillUrl ? _c("el-link", {
          attrs: {
            type: "primary",
            icon: "el-icon-link",
            target: "_blank",
            href: _vm.getFormatedURL(scope.row.ewayBillUrl)
          }
        }) : _vm._e()], 1) : _vm._e()];
      }
    }], null, false, 762724705)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      width: "130",
      label: "Date Made On",
      prop: "actualCreatedTimestamp",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(_vm.formatDate(scope.row.actualCreatedTimestamp)))])];
      }
    }], null, false, 3921793950)
  }), !_vm.query.paymentType ? _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", {
          staticClass: "action-cell"
        }, [_vm.isCnDnType(scope.row) && !scope.row.fromTally ? _c("el-tooltip", {
          attrs: {
            content: "Download invoice",
            placement: "top",
            "open-delay": 400
          }
        }, [_c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-download",
            circle: ""
          },
          on: {
            click: function ($event) {
              return _vm.downloadInvoice(scope.row);
            }
          }
        })], 1) : _vm._e(), _vm.hasPdfAttachment(scope.row) ? _c("el-tooltip", {
          attrs: {
            content: "View attachment",
            placement: "top",
            "open-delay": 400
          }
        }, [_c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-view",
            circle: ""
          },
          on: {
            click: function ($event) {
              return _vm.viewPdf(scope.row, true);
            }
          }
        })], 1) : _vm._e(), _vm.isSuperAdmin && _vm.isDirectlyEditable(scope.row) ? _c("el-tooltip", {
          attrs: {
            content: "Edit entry",
            placement: "top",
            "open-delay": 400
          }
        }, [_vm.isSuperAdmin && _vm.isDirectlyEditable(scope.row) ? _c("el-button", {
          attrs: {
            size: "mini",
            icon: "el-icon-edit",
            circle: ""
          },
          on: {
            click: function ($event) {
              return _vm.openEditDialog(scope.row);
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm.isRouteEditable(scope.row) && _vm.isSuperAdmin ? _c("el-tooltip", {
          attrs: {
            content: "Edit",
            placement: "top",
            "open-delay": 400
          }
        }, [_c("router-link", {
          attrs: {
            to: "/ledgers/edit/" + scope.row.id
          }
        }, [_vm.isSuperAdmin ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-edit",
            circle: ""
          }
        }) : _vm._e()], 1)], 1) : _vm._e(), _vm.isSuperAdmin && scope.row.paymentType !== "Invoice" ? _c("el-tooltip", {
          attrs: {
            content: "Delete",
            placement: "top",
            "open-delay": 400
          }
        }, [_c("el-button", {
          attrs: {
            size: "mini",
            type: "danger",
            icon: "el-icon-delete",
            circle: ""
          },
          on: {
            click: function ($event) {
              return _vm.deleteEntry(scope.row);
            }
          }
        })], 1) : _vm._e(), _vm.isCnDnType(scope.row) && scope.row.paymentType !== "Credit Note" && !scope.row.fromTally ? _c("el-dropdown", {
          attrs: {
            trigger: "click",
            placement: "bottom-end",
            size: "mini"
          }
        }, [_c("el-button", {
          attrs: {
            size: "mini",
            icon: "el-icon-more",
            circle: ""
          }
        }), _c("el-dropdown-menu", {
          attrs: {
            slot: "dropdown"
          },
          slot: "dropdown"
        }, [_c("el-dropdown-item", {
          nativeOn: {
            click: function ($event) {
              return _vm.createEInvoice(scope.row.id);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-document"
        }), _vm._v(" Create E-Invoice ")]), _c("el-dropdown-item", {
          nativeOn: {
            click: function ($event) {
              return _vm.createEway(scope.row.id);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-truck"
        }), _vm._v(" Create E-Way ")])], 1)], 1) : _vm._e()], 1)];
      }
    }], null, false, 256230069)
  }) : _vm._e()], 1) : _vm._e(), _vm.listQuery.dealerId && !_vm.applyFilters ? _c("el-row", {
    staticStyle: {
      "margin-right": "110px"
    },
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "align-right",
    attrs: {
      span: 24
    }
  }, [_vm._v(" Closing Balance: "), _c("inr", {
    attrs: {
      number: Math.round(_vm.closingBalance)
    }
  })], 1)], 1) : _vm._e(), _c("el-dialog", {
    attrs: {
      title: "Edit Narration",
      visible: _vm.dialogFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "New Narration",
      "label-width": "120px"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea"
    },
    model: {
      value: _vm.form.comments,
      callback: function ($$v) {
        _vm.$set(_vm.form, "comments", $$v);
      },
      expression: "form.comments"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogFormVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveNarration
    }
  }, [_vm._v("Confirm")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "Edit Date",
      visible: _vm.dialogDateFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogDateFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.dateForm
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "New Date",
      "label-width": "120px"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      placeholder: "Select date"
    },
    model: {
      value: _vm.dateForm.createdTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.dateForm, "createdTimestamp", $$v);
      },
      expression: "dateForm.createdTimestamp"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogDateFormVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.dateSaving
    },
    on: {
      click: _vm.saveDateEdit
    }
  }, [_vm._v(" Confirm ")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "Edit Entry",
      visible: _vm.dialogEditFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogEditFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.editForm
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Amount",
      "label-width": "120px"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number"
    },
    model: {
      value: _vm.editForm.amount,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "amount", _vm._n($$v));
      },
      expression: "editForm.amount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Dealer",
      "label-width": "120px"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: "Search Dealer"
    },
    model: {
      value: _vm.editForm.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "dealerId", $$v);
      },
      expression: "editForm.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Date",
      "label-width": "120px"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "Select date"
    },
    model: {
      value: _vm.editForm.createdTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "createdTimestamp", $$v);
      },
      expression: "editForm.createdTimestamp"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Updated Date",
      "label-width": "120px"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "Select date",
      disabled: ""
    },
    model: {
      value: _vm.editForm.updatedTimestamp,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "updatedTimestamp", $$v);
      },
      expression: "editForm.updatedTimestamp"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogEditFormVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitEditDialog
    }
  }, [_vm._v("Update")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "Import Ledger Entries",
      visible: _vm.importDialogVisible,
      width: "1150px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.importDialogVisible = $event;
      },
      close: _vm.resetImport
    }
  }, [_c("div", {
    staticClass: "form-block import-block",
    staticStyle: {
      width: "100%"
    }
  }, [_c("div", {
    staticClass: "source",
    staticStyle: {
      width: "100%"
    }
  }, [_c("el-form", {
    ref: "importPostForm",
    staticClass: "demo-form",
    attrs: {
      model: _vm.importPostForm,
      "status-icon": "",
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "warning",
      disabled: _vm.processingLedgerImport
    },
    on: {
      click: function ($event) {
        _vm.showImportWarningDialog = true;
      }
    }
  }, [_vm._v(" Click to Upload ")]), _c("div", {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" Only Excel files (.xlsx, .xls) are allowed ")]), _c("el-upload", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "importUploadRef",
    staticClass: "upload-demo",
    attrs: {
      action: "",
      "on-change": _vm.handleImportFileChange,
      "on-remove": _vm.handleImportFileRemove,
      "on-exceed": _vm.handleImportExceed,
      "auto-upload": false,
      limit: 1,
      accept: ".xlsx,.xls"
    },
    model: {
      value: _vm.importPostForm.file,
      callback: function ($$v) {
        _vm.$set(_vm.importPostForm, "file", $$v);
      },
      expression: "importPostForm.file"
    }
  })], 1), _vm.showImportPreview ? _c("div", {
    staticClass: "preview-section"
  }, [_c("h3", [_vm._v("Data Preview (" + _vm._s(_vm.importExcelData.length) + " rows)")]), _c("div", {
    staticClass: "preview-table-scroll"
  }, [_c("el-table", {
    staticStyle: {
      width: "100%",
      "margin-top": "20px"
    },
    attrs: {
      data: _vm.importExcelData,
      fit: "",
      border: "",
      "max-height": "350"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Status",
      "min-width": "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.__status === "success" ? _c("el-tag", {
          attrs: {
            type: "success",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-check"
        }), _vm._v(" Uploaded ")]) : scope.row.__status === "error" ? _c("el-tag", {
          attrs: {
            type: "danger",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-close"
        }), _vm._v(" Failed ")]) : scope.row.__status === "uploading" ? _c("el-tag", {
          attrs: {
            type: "warning",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-loading"
        }), _vm._v(" Uploading ")]) : _c("el-tag", {
          attrs: {
            type: "info",
            size: "mini"
          }
        }, [_vm._v(" Pending ")]), scope.row.__status === "error" && scope.row.__error ? _c("div", {
          staticClass: "row-error-text"
        }, [_vm._v(" " + _vm._s(scope.row.__error) + " ")]) : _vm._e()];
      }
    }], null, false, 2906182276)
  }), _c("el-table-column", {
    attrs: {
      prop: "dealerId",
      label: "Dealer ID",
      "min-width": "90"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "dealerName",
      label: "Dealer Name",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "amount",
      label: "Amount",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "entryDate",
      label: "Entry Date",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "paymentType",
      label: "Payment Type",
      "min-width": "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "paymentSubType",
      label: "Payment Sub Type",
      "min-width": "140"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "narration",
      label: "Narration",
      "min-width": "140"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createdBy",
      label: "Created By",
      "min-width": "110"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "s3url",
      label: "S3 URL",
      "min-width": "120"
    }
  })], 1)], 1)]) : _vm._e()], 1), _c("el-dialog", {
    attrs: {
      title: "Important Instructions",
      visible: _vm.showImportWarningDialog,
      width: "700px",
      "append-to-body": "",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.showImportWarningDialog = $event;
      }
    }
  }, [_c("div", {
    staticClass: "warning-content"
  }, [_c("el-alert", {
    attrs: {
      title: "Please read carefully before uploading",
      type: "warning",
      closable: false,
      "show-icon": ""
    }
  }), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("p", [_c("strong", [_vm._v("1.")]), _vm._v(" Upload only when the dealer(s) referenced already exist in the system. ")]), _c("p", [_c("strong", [_vm._v("2.")]), _vm._v(" "), _c("code", [_vm._v("dealer id")]), _vm._v(" is the most important column and is used to match the dealer. "), _c("code", [_vm._v("dealer name")]), _vm._v(" is for reference only and is not used for matching. ")]), _c("p", [_c("strong", [_vm._v("3.")]), _vm._v(" The Excel should strictly follow the column patterns as follows: ")]), _c("ul", {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c("li", [_vm._v("dealer id")]), _c("li", [_vm._v("dealer name")]), _c("li", [_vm._v("amount")]), _c("li", [_vm._v("entry date (format: DD-MM-YYYY)")]), _c("li", [_vm._v("payment type")]), _c("li", [_vm._v("payment sub type")]), _c("li", [_vm._v("narration")]), _c("li", [_vm._v("created by")]), _c("li", [_vm._v("s3url")])]), _c("p", [_c("strong", [_vm._v("4.")]), _vm._v(" "), _c("code", [_vm._v("paymentType")]), _vm._v(" must be one of: Credit Note, Debit Note, Credit Note-Item Wise, Debit Note-Item Wise, Purchase, Credit Note Inward, Invoice, Payment. ")]), _c("p", [_c("strong", [_vm._v("5.")]), _vm._v(" "), _c("code", [_vm._v("amount")]), _vm._v(" must be a positive number. "), _c("code", [_vm._v("s3url")]), _vm._v(" is optional and can be left blank. ")]), _c("p", [_c("strong", [_vm._v("6.")]), _vm._v(" "), _c("code", [_vm._v("createdBy")]), _vm._v(" should identify who created/entered the record (e.g. admin name or ID). ")])])], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.showImportWarningDialog = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.proceedWithImportUpload
    }
  }, [_vm._v(" I Understand, Proceed ")])], 1)]), _c("el-dialog", {
    attrs: {
      visible: _vm.processingLedgerImport,
      width: "440px",
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.processingLedgerImport = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "20px"
    }
  }, [_c("i", {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "48px",
      color: "#409eff"
    }
  }), _c("p", {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "16px"
    }
  }, [_vm._v(" Importing row " + _vm._s(_vm.importProgress.current) + " of " + _vm._s(_vm.importProgress.total) + "... ")]), _c("el-progress", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      percentage: _vm.importProgressPercentage,
      "stroke-width": 14
    }
  }), _c("p", {
    staticStyle: {
      color: "#909399",
      "font-size": "14px",
      "margin-top": "15px"
    }
  }, [_vm._v(" Do not close this window ")])], 1)])], 1), _vm.showImportPreview ? _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      disabled: _vm.processingLedgerImport
    },
    on: {
      click: _vm.cancelImport
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.processingLedgerImport
    },
    on: {
      click: _vm.handleImportSubmit
    }
  }, [_vm._v(" Import Data ")])], 1) : _vm._e()]), _vm.listQuery.dealerId && !_vm.query.paymentType ? _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit,
      "page-sizes": [50, 100, 200, 500, 1000]
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  }) : _vm._e(), _vm.listQuery.dealerId && _vm.query.paymentType ? _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit,
      "page-sizes": [50, 100, 200, 500, 1000]
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getListByPaymentType
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };